import { render, staticRenderFns } from "./new-mega.vue?vue&type=template&id=4d2fd204&scoped=true"
import script from "./new-mega.vue?vue&type=script&lang=js"
export * from "./new-mega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2fd204",
  null
  
)

export default component.exports